<template>
  <div>
    <section class="section--title-page">
      <h1>{{ __('views.DocumentsTableSharing.page_title') }}</h1>
    </section>
    <section>
      <!-- Buttons add folder, add file-->
      <div class="row">
        <div v-if="is_admin" class="col-md-2">
          <a href="#" @click="openAddFolder()" class="btn btn--green">
            <i class="fas fa-folder"></i>
            {{ __('views.DocumentsTableSharing.actions.new_folder') }}
          </a>
        </div>
        <div v-if="user_can_edit" class="col-md-2">
          <a href="#" @click="openAddFile()" class="btn btn--green">
            <i class="fas fa-file"></i>
            {{ __('views.DocumentsTableSharing.actions.new_file') }}
          </a>
        </div>
        <div v-if="user_can_edit" class="col-md-2">
          <a href="#" @click="openAddLink()" class="btn btn--green">
            <i class="fas fa-link"></i>
            {{ __('views.DocumentsTableSharing.actions.new_link') }}
          </a>
        </div>
      </div>
    </section>
    <section style="margin-top: 20px">
      <label>{{ this.path_folder }}</label>
      <label v-if="is_loading">

        <i  class="fas fa-spinner fa-spin ml-2"></i>
        {{ __('misc.loading') }}
      </label>
    </section>
    <div class="table--custom" style="margin-top: 20px">
      <!-- HEADER -->
      <div class="single--row single--row-head single--row-head--mini">
        <!-- CAN EDIT FILES -->
        <div class="row" v-if="user_can_edit">          
          <div :class="chatbot_module_on ? 'col-lg-2 col-md-2 col-12' : 'col-lg-4 col-md-4 col-12'">
            <div class="single--row-info pointer-icon sort-col-header" @click="sortBy('name')">
              <span>{{ __('views.DocumentsTableSharing.table.column_name') }}</span>
              <i :class="sortIcon('name')"></i>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info pointer-icon sort-col-header" @click="sortBy('updated_at')">
              <span>{{ __('views.DocumentsTableSharing.table.column_last_update') }}</span>
              <i :class="sortIcon('updated_at')"></i>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">{{ __('views.DocumentsTableSharing.table.column_actions') }}</div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">{{ __('views.DocumentsTableSharing.table.column_sent_to') }}</div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">{{ __('views.DocumentsTableSharing.table.column_read_by') }}</div>
          </div>
          <div v-if="chatbot_module_on" class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">{{ __('views.DocumentsTableSharing.table.column_chatbot_sync') }}</div>
          </div>          
        </div>
        <div v-else class="row">
          <div class="col-8">
            <div class="single--row-info pointer-icon sort-col-header" @click="sortBy('name')">
              <span>{{ __('views.DocumentsTableSharing.table.column_name') }}</span>
              <i :class="sortIcon('name')"></i>
            </div>
          </div>
          <div class="col-4">
            <div class="single--row-info pointer-icon sort-col-header" @click="sortBy('updated_at')">
              <span>{{ __('views.DocumentsTableSharing.table.column_last_update') }}</span>
              <i :class="sortIcon('updated_at')"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- All ROWS -->
      <div class="single--row single--row-input">
        <!-- ..previus folder folder-->
        <div class="single--row-input-content" v-if="folder_id !== null">
          <div class="row" v-if="user_can_edit">
            <div class="col-lg-4 col-md-4 col-12 pointer-icon">
              <div
                class="single--row-info"
                @click="readFolder(previous_folder_id)">
                <span
                  ><i class="fas fa-arrow-up"></i>&nbsp;{{ __('views.DocumentsTableSharing.navigation.parent_folder') }}
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="col-12 pointer-icon m-2">
              <div
                class="single--row-info"
                @click="readFolder(previous_folder_id)"
              >
                <span
                  ><i class="fas fa-arrow-up"></i>&nbsp;{{ __('views.DocumentsTableSharing.navigation.parent_folder') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Folder ROWs-->
        <div class="single--row-input-content" v-for="folder in sorted_folders">
          <div class="row" v-if="user_can_edit">
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info" @click="readFolder(folder.id)">
                <span class="pointer-icon m-2"
                  ><i class="far fa-folder"></i>&nbsp;{{ folder.name }}</span
                >
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-12" v-if="user_can_edit">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info" v-if="folder.canEdit">
                <span>
                  <a href="#" @click="editFolder(folder.id)">
                    <i class="fas fa-edit"></i> </a
                  >&nbsp;
                  <a href="#" @click="deleteFolder(folder)">
                    <i class="fas fa-trash"></i> </a
                  >&nbsp;
                  <a href="#" @click="massivePermissionFolder(folder)">
                    <i class="fas fa-share"></i> </a
                  >&nbsp;
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="user_can_edit">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="user_can_edit">
              <div class="single--row-info">
                <span></span>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12">
              <div class="single--row-info" @click="readFolder(folder.id)">
                <span class="pointer-icon m-2"
                  ><i class="far fa-folder"></i>&nbsp;{{ folder.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <!--File ROW-->
        <div class="single--row-input-content" v-for="file in sorted_files">
          <div class="row" v-if="user_can_edit">
            <div :class="chatbot_module_on ? 'col-lg-2 col-md-2 col-12' : 'col-lg-4 col-md-4 col-12'">
              <div v-if="file.canView" class="single--row-info">
                <a
                  href="#"
                  class="mt-3 ml-2"
                  @click="viewFile(file.id, file.url, 1)"
                  ><i class="far fa-file"></i>&nbsp;{{ file.name }} </a
                >&nbsp;
              </div>
              <div v-else class="single--row-info">
                <span class="mt-3 ml-2"
                  ><i class="far fa-file"></i>&nbsp;{{ file.name }}</span
                >
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                {{ file.lastUpdate }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <span>
                  <a v-if="file.canEdit" href="#" @click="moveFile(file.id, 1)">
                    <i class="fas fa-edit"></i> </a
                  >&nbsp;
                  <a
                    v-if="file.canEdit"
                    href="#"
                    @click="deleteFile(file.id, 1)"
                  >
                    <i class="fas fa-trash"></i> </a
                  >&nbsp;
                  <a v-if="file.canEdit" href="#" @click="sendFile(file.id, 1)">
                    <i class="fas fa-share"></i> </a
                  >&nbsp;
                  <a v-if="file.canBeSendToTexract && chatbot_module_on" href="#" @click="sincFile(file.id, 1)">
                    <i class="fa-light fa-message-bot"></i> </a
                  >&nbsp;
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="file.canView">
              <div class="single--row-info">
                <span @click="openPeopleState(file.id, 1, 1)">
                  <div
                    :style="
                      'cursor:pointer;width: 30px;height: 30px;background-color:' +
                      file.color_is_sent +
                      ';border-radius: 50%;'
                    "
                  ></div>
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="file.canView">
              <div class="single--row-info">
                <span @click="openPeopleState(file.id, 1, 2)">
                  <div
                    :style="
                      'cursor:pointer;width: 30px;height: 30px;background-color:' +
                      file.color_is_seen +
                      ';border-radius: 50%;'
                    "
                  ></div>
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="file.canView && chatbot_module_on">
              <div class="single--row-info">
                <div :style="'cursor:pointer; width: 30px; height: 30px; background-color: ' + file.chatbot_sinc_color + '; border-radius: 50%;'"></div>                
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-8">
              <div v-if="file.canView" class="single--row-info">
                <a
                  href="#"
                  class="mt-3 ml-2"
                  @click="viewFile(file.id, file.url, 1)"
                  ><i class="far fa-file"></i>&nbsp;{{ file.name }} </a
                >&nbsp;
              </div>
              <div v-else class="single--row-info">
                <span class="mt-3 ml-2"
                  ><i class="far fa-file"></i>&nbsp;{{ file.name }}</span
                >
              </div>
            </div>
            <div class="col-4">
              <div class="single--row-info last-update-cell">{{ file.lastUpdate }}</div>
            </div>
          </div>
        </div>
        <!--  LINK LIST -->
        <div class="single--row-input-content" v-for="link in sorted_links">
          <div class="row" v-if="user_can_edit">
            <div :class="chatbot_module_on ? 'col-lg-2 col-md-2 col-12' : 'col-lg-4 col-md-4 col-12'">
              <div v-if="link.canView" class="single--row-info">
                <span class="m-2">
                  <a href="#" @click="viewLink(link.id, link.url, 2)"
                    ><i class="far fa-link"></i>&nbsp;{{ link.name }} </a
                  >&nbsp;
                </span>
              </div>
              <div v-else class="single--row-info">
                <span class="m-2"
                  ><i class="far fa-link"></i>&nbsp;{{ link.name }}</span
                >
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">                
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <span>
                  <a v-if="link.canEdit" href="#" @click="moveLink(link.id)">
                    <i class="fas fa-edit"></i> </a
                  >&nbsp;
                  <a v-if="link.canEdit" href="#" @click="deleteLink(link.id)">
                    <i class="fas fa-trash"></i> </a
                  >&nbsp;
                  <a v-if="link.canEdit" href="#" @click="sendFile(link.id, 2)">
                    <i class="fas fa-share"></i> </a
                  >&nbsp;
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="link.canView">
              <div class="single--row-info">
                <span @click="openPeopleState(link.id, 2, 1)">
                  <div
                    :style="
                      'cursor:pointer;width: 30px;height: 30px;background-color:' +
                      link.color_is_sent +
                      ';border-radius: 50%;'
                    "
                  ></div>
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="link.canView">
              <div class="single--row-info">
                <span @click="openPeopleState(link.id, 2, 2)">
                  <div
                    :style="
                      'cursor:pointer;width: 30px;height: 30px;background-color:' +
                      link.color_is_seen +
                      ';border-radius: 50%;'
                    "
                  ></div>
                </span>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12">
              <div v-if="link.canView" class="single--row-info">
                <span class="m-2">
                  <a href="#" @click="viewLink(link.id, link.url, 2)"
                    ><i class="far fa-link"></i>&nbsp;{{ link.name }} </a
                  >&nbsp;
                </span>
              </div>
              <div v-else class="single--row-info m-2">
                <span><i class="far fa-link"></i>&nbsp;{{ link.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {    
    let folder = this.current_folder == 0 ? null : this.current_folder;
    this.readFolder(folder);
  },
  props: {
    api_url: {
      type: String,
      required: true,
    },
    add_folder_url: {
      type: String,
      required: true,
    },
    add_file_url: {
      type: String,
      required: true,
    },
    add_link_url: {
      type: String,
      required: true,
    },
    user_can_edit: {
      type: Boolean,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    model_class: {
      type: String,
      required: true,
    },
    module_name: {
      type: String,
      required: true,
    },
    model_id: {
      type: Number,
      required: true,
    },
    current_folder: {
      type: Number,
      required: false,
      default: null,
    },
    chatbot_module_on: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      folder_list: {},
      file_list: {},
      link_list: {},
      path_folder: "/",
      folder_id: null,
      previous_folder_id: 0,
      color_is_sent: "white",
      color_is_seen: "white",
      color_is_printed: "white",
      userUrl: this.is_admin ? "" : "-user",
      is_loading: false,
      sort_by: 'updated_at',
      sort_dir: 'desc',
    };
  },
  computed: {
    sorted_folders() {
      const list = Object.values(this.folder_list);
      if (!this.sort_by || this.sort_by === 'updated_at') return list;
      return list.slice().sort((a, b) => {
        const va = (a.name || '').toLowerCase();
        const vb = (b.name || '').toLowerCase();
        return this.sort_dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
      });
    },
    sorted_files() {
      const list = Object.values(this.file_list);
      if (!this.sort_by || this.sort_by === 'updated_at') return list;
      return list.slice().sort((a, b) => {
        const va = (a[this.sort_by] || '').toLowerCase();
        const vb = (b[this.sort_by] || '').toLowerCase();
        return this.sort_dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
      });
    },
    sorted_links() {
      const list = Object.values(this.link_list);
      if (!this.sort_by || this.sort_by === 'updated_at') return list;
      return list.slice().sort((a, b) => {
        const va = (a.name || '').toLowerCase();
        const vb = (b.name || '').toLowerCase();
        return this.sort_dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
      });
    },
  },
  methods: {
    sortBy(field) {
      if (this.sort_by === field) {
        this.sort_dir = this.sort_dir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort_by = field;
        this.sort_dir = 'asc';
      }
      if (this.sort_by === 'updated_at') this.readFolder(this.folder_id);
    },
    sortIcon(field) {
      if (this.sort_by !== field) return 'fas fa-sort';
      return this.sort_dir === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },
    editFolder(folder) {
      app.__vue__.$refs.vue_sidebar.toggle(
        "/media-structure/action/edit-folder/" +
          folder +
          "?module=" +
          this.module_name +
          "&model_id=" +
          this.model_id +
          "&share=1"
      );
    },
    deleteFolder(folder) {
      Vue.swal
        .fire({
          title: this.__('views.DocumentsTableSharing.confirm.delete_folder_title').replace(':name', folder.name),
          text: this.__('views.DocumentsTableSharing.confirm.delete_folder_text'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/media-structure/action/destroy/" + folder.id)
              .then((response) => {
                this.readFolder(this.folder_id);
              });
          }
        });
    },
    massivePermissionFolder(folder) {
      if (folder == null) {
        return;
      }
      app.__vue__.$refs.vue_popup.toggle(this.__('misc.massive_assign_permission'),
        "people-media/action/share-file-from-folder/" + folder.id
      );
    },
    viewFile(file, url, type) {
      axios
        .put(
          "/people-media/action/set-open-file/" +
            file +
            "/media/" +
            type +
            "/type"
        )
        .then((response) => {
          window.open(url, "_blank");
        })
        .catch(function (error) {
          alert(error);
        });
    },
    viewLink(file, url, type) {
      axios
        .put(
          "/people-media/action/set-open-file/" +
            file +
            "/media/" +
            type +
            "/type"
        )
        .then((response) => {
          Vue.swal
            .fire({
              title: this.__('views.DocumentsTableSharing.confirm.external_link_title'),
              text: this.__('views.DocumentsTableSharing.confirm.external_link_text'),
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "OK",
            })
            .then((result) => {
              if (result.value) {
                let win = window.open(url, "_blank");
              }
            });
        })
        .catch(function (error) {
          alert(error);
        });
    },

    printFile(file, url, type) {
      axios
        .put(
          "/people-media/action/set-printed-file/" +
            file +
            "/media/" +
            type +
            "/type"
        )
        .then((response) => {
          let win = window.open(url, "_blank");
          let is_chrome = function () {
            return Boolean(window.chrome);
          };
          if (is_chrome) {
            win.print();

            //give them 10 seconds to print, then close
          } else {
            win.print();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    deleteFile(file) {
      Vue.swal
        .fire({
          title: this.__('views.DocumentsTableSharing.confirm.delete_file_title'),
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("media-structure/action/destroy-file/" + file + "/media")
              .then((response) => {
                this.readFolder(this.folder_id);
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },
    deleteLink(link) {
      Vue.swal
        .fire({
          title: this.__('views.DocumentsTableSharing.confirm.delete_link_title'),
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(
                "/media-structure/action/destroy-link/" + link + "/media-link"
              )
              .then((response) => {
                this.readFolder(this.previous_folder_id);
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },
    openPeopleState(file, type, flag) {
      app.__vue__.$refs.vue_sidebar.toggle(
        "/people-media/action/check-state-file/" +
          file +
          "/media/" +
          type +
          "/type?flag=" +
          flag
      );
    },
    openAddFolder() {
      //app.__vue__.$refs.vue_popup.toggle("add_folder",this.add_folder_url);
      app.__vue__.$refs.vue_popup.toggle(
        "add_folder",
        this.add_folder_url +
          "&module=" +
          this.module_name +
          "&folder=" +
          this.folder_id +
          "&model_id=" +
          this.model_id +
          "&share=1"
      );
    },
    openAddFile() {
      app.__vue__.$refs.vue_popup.toggle(
        "add_file",
        this.add_file_url +
          "&folder=" +
          this.folder_id +
          "&module=" +
          this.module_name +
          "&share=1"
      );
    },
    openAddLink() {
      app.__vue__.$refs.vue_popup.toggle(
        "add_file",
        this.add_link_url +
          "&module=" +
          this.module_name +
          "&folder=" +
          this.folder_id +
          "&model_id=" +
          this.model_id +
          "&share=1"
      );
    },
    sendFile(file, type) {
      app.__vue__.$refs.vue_popup.toggle('',
        "/people-media/action/edit-send-file/" +
          file +
          "/media/" +
          type +
          "/type"
      );
    },
    sincFile(fileId) {      
      Vue.swal
        .fire({
          title: this.__('views.DocumentsTableSharing.confirm.sync_chatbot_title'),
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {  
          if (result.value) {
            axios
            .post('people-medias/action/sinc-to-chabot/' + fileId)
            .then((response) => {
              Vue.$toast.open({
                message: response.data.message,
                type: response.data.result ? "success" : "error",
                position: "top-right"
              });
              this.readFolder(this.folder_id);
            })
            .catch(function (error) {
              alert(error);
            });
          }
      });
    },
    moveFile(file) {
      app.__vue__.$refs.vue_popup.toggle(
        this.__('views.DocumentsTableSharing.actions.move_file'),
        "/media-structure/action/move-file/" +
          file +
          "/media?model_class=" +
          this.model_class +
          "&module=" +
          this.module_name +
          "&model_id=" +
          this.model_id +
          "&folder=" +
          this.folder_id +
          "&share=1"
      );
    },
    moveLink(link) {
      app.__vue__.$refs.vue_popup.toggle(
        this.__('views.DocumentsTableSharing.actions.move_file'),
        "/media-structure/action/move-link/" +
          link +
          "/link?model_class=" +
          this.model_class +
          "&module=" +
          this.module_name +
          "&model_id=" +
          this.model_id +
          "&folder=" +
          this.folder_id +
          "&share=1"
      );
      //app.__vue__.$refs.vue_popup.toggle("Move File","media-structure/action/move-link/"+link+"/link?model_class="+this.model_class);
    },

    readFolder(folder) {
      this.folder_id = folder;
      this.is_loading = true;

      let params = {
        folder: folder,
        sort_by: this.sort_by,
        sort_dir: this.sort_dir,
      };

      axios
        .get(this.api_url, { params: params })
        .then((response) => {
          this.file_list = response.data.files;
          this.link_list = response.data.links;
          this.folder_list = response.data.folders;
          this.previous_folder_id = response.data.previous_folder;
          this.color_is_sent = response.data.color_is_sent;
          this.color_is_seen = response.data.color_is_seen;
          this.color_is_printed = response.data.color_is_printed;
          this.path_folder = response.data.path_folder;
          
        })
        .catch(function (error) {
          alert(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
};
</script>

<style>
.pointer-icon {
  cursor: pointer;
}
.sort-col-header {
  display: inline-flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 4px;
}
.sort-col-header i {
  font-size: 0.8em;
  line-height: 1;
  margin-bottom: 1px;
}
.last-update-cell {
  text-align: center !important;
}
</style>
